import { render, staticRenderFns } from "./AddDepartmentOU.vue?vue&type=template&id=4b7cb21e&scoped=true"
import script from "./AddDepartmentOU.vue?vue&type=script&lang=js"
export * from "./AddDepartmentOU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7cb21e",
  null
  
)

export default component.exports